/**
 * @fileoverview Renders list of verification methods.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */
import {useIsSmallViewport} from '/ui/lib/responsivity';

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/verifyentity.module.scss';

export function VerificationVideoTips() {
  const isSmallViewport = useIsSmallViewport();

  return (
    <div className={styles.verificationFlowVideoSteps}>
      {isSmallViewport && (
        <p>
          <strong>{yext.msg('Tips')}</strong>
        </p>
      )}
      <p>
        {yext.msg('Capture all 3 of location, equipment, and proof of management in 1 continuous recording:')}
        <ul>
          <li>{yext.msg('Your location should match your Business Profile address')}</li>
          <li>{yext.msg('Your business name and category should match your Business Profile')}</li>
          <li>{yext.msg('You\'re authorized to represent this business - unlock store entrance, operate payment tool, or display proof of address')}</li>
        </ul>
      </p>
      <p>
        {yext.msg('Take your time. Most successful videos are 1-2 minutes. Videos longer than 5 minutes won\'t be accepted.')}
      </p>
      <p>
        {yext.msg('Start outside. Capture your business surroundings first before moving inside.')}
      </p>
      <p>
        {yext.msg('Avoid capturing faces or sensitive documents')}
      </p>
      <p>
        {yext.msg('If your business does not have a physical location, focus on recording equipment you use for your business (such as a branded vehicle, branded marketing materials, the workspace, tools and equipment, business registration, invoices, utility bills or other documents with your business name).')}
      </p>
    </div>
  );
}
